import React from "react";
import { BlockMath, InlineMath } from "react-katex";

/**
 * Renders text that may contain LaTeX markup.
 * Handles \begin{...}...\end{...}, \frac, \sqrt, and all standard delimiters.
 */
export const renderWithLatex = (text) => {
  if (!text) return null;

  let processed = text;

  // If the text already contains \( or \[, skip auto-wrapping
  const hasDelimiters = /\\[\(\)\[\]]/.test(processed);

  if (!hasDelimiters) {
    // 1. Wrap \begin{...}...\end{...} (matrix, cases, etc.)
    processed = processed.replace(
      /(\\begin\{[^}]+\}[\s\S]*?\\end\{[^}]+\})/g,
      '\\($1\\)'
    );

    // 2. Wrap \frac{...}{...}
    processed = processed.replace(
      /\\frac\s*(\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})\s*(\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})/g,
      '\\($&\\)'
    );

    // 3. Wrap \sqrt[...]{...} and \sqrt{...}
    processed = processed.replace(
      /\\sqrt(?:\[[^\]]*\])?\s*\{((?:[^{}]|\{[^{}]*\})*)\}/g,
      '\\($&\\)'
    );

    // 4. Wrap \dfrac, \tfrac, \cfrac
    processed = processed.replace(
      /\\[dtc]frac\s*\{[^}]*\}\s*\{[^}]*\}/g,
      '\\($&\\)'
    );

    // 5. Wrap any remaining LaTeX commands (e.g., \alpha, \beta)
    processed = processed.replace(
      /(\\[a-zA-Z]+(?:\{[^}]*\})?(?:\{[^}]*\})?)/g,
      (match) => {
        if (match.includes('\\(') || match.includes('\\)')) return match;
        return '\\( ' + match + ' \\)';
      }
    );
  }

  // Render display math \[...\]
  if (processed.includes('\\[') && processed.includes('\\]')) {
    const parts = []; let last = 0;
    const regex = /\\\[(.*?)\\\]/gs; let match;
    while ((match = regex.exec(processed)) !== null) {
      if (match.index > last) parts.push(<span key={`t-${last}`}>{processed.substring(last, match.index)}</span>);
      parts.push(<BlockMath key={`m-${match.index}`} math={match[1]} />);
      last = match.index + match[0].length;
    }
    if (last < processed.length) parts.push(<span key={`t-${last}`}>{processed.substring(last)}</span>);
    return <>{parts}</>;
  }

  // Render inline math \(...\)
  if (processed.includes('\\(') && processed.includes('\\)')) {
    const parts = []; let last = 0;
    const regex = /\\\((.*?)\\\)/gs; let match;
    while ((match = regex.exec(processed)) !== null) {
      if (match.index > last) parts.push(<span key={`t-${last}`}>{processed.substring(last, match.index)}</span>);
      parts.push(<InlineMath key={`m-${match.index}`} math={match[1]} />);
      last = match.index + match[0].length;
    }
    if (last < processed.length) parts.push(<span key={`t-${last}`}>{processed.substring(last)}</span>);
    return <>{parts}</>;
  }

  // No LaTeX found, return plain text
  return <span>{processed}</span>;
};